import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {GonvarriOrderHistoryComponent} from "../../components/gonvarri-order-history/gonvarri-order-history.component";
import {AuthGuard, I18nModule, provideConfig, UrlModule} from "@spartacus/core";
import {IconModule, ListNavigationModule, MediaModule, SortingModule, SpinnerModule} from "@spartacus/storefront";
import {RouterModule} from "@angular/router";
import {FormsModule} from "@angular/forms";
import {NgSelectModule} from "@ng-select/ng-select";
import {AppModule} from "../../app.module";
import {GonvarriDownloadOrderPdfModule} from "../gonvarri-download-order-pdf/gonvarri-download-order-pdf.module";

@NgModule({
  declarations: [
    GonvarriOrderHistoryComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgSelectModule,
    ListNavigationModule,
    UrlModule,
    I18nModule,
    SpinnerModule,
    MediaModule,
    IconModule,
    GonvarriDownloadOrderPdfModule
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        GonvarriOrderHistoryComponent: {
          component: GonvarriOrderHistoryComponent,
          guards: [AuthGuard],
        },
        AccountOrderHistoryComponent: {
          component: GonvarriOrderHistoryComponent,
          guards: [AuthGuard],
        },
        OrderHistoryComponent: {
          component: GonvarriOrderHistoryComponent,
          guards: [AuthGuard],
        }
      }
    })
  ]
})
export class GonvarriOrderHistoryModule { }
